module.exports = __webpack_public_path__ + "img/banner.0ee4749c.png";